// The one place this application talks GraphQL. Bring in Apollo the day it needs a cache,
// a normalised store or subscriptions, and delete this file then.
export interface GraphQLAnswer<T> {
    data?: T | null;
    errors?: { message: string; extensions?: { code?: string } }[];
}

export class ApiUnavailable extends Error {}

// Does not throw on a GraphQL error, only when the endpoint is unreachable: a refusal
// carrying a business code is an answer, and each caller words it for its own screen.
export const graphql = async <T>(
    query: string,
    variables?: Record<string, unknown>,
    idToken?: string
): Promise<GraphQLAnswer<T>> => {
    const url = import.meta.env.PUBLIC_CLIENT_API_URL;
    if (!url) {
        // A missing configuration is not a refusal.
        throw new ApiUnavailable('PUBLIC_CLIENT_API_URL is not set');
    }

    let response: Response;
    try {
        response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
            },
            body: JSON.stringify({ query, variables }),
        });
    } catch (failure) {
        throw new ApiUnavailable(failure instanceof Error ? failure.message : 'network failure');
    }

    try {
        return (await response.json()) as GraphQLAnswer<T>;
    } catch {
        // An unreadable body (e.g. an HTML 502) is not an empty result.
        throw new ApiUnavailable(`unreadable answer (HTTP ${response.status})`);
    }
};
